import { useEffect, useState } from "react";
import { MEDIA_QUERIES } from "@/utils/constants/breakpoints";

export type SidebarLayoutMode = "sheet" | "collapsed" | "expanded";

type BreakpointState = {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    sidebarMode: SidebarLayoutMode;
};

function readBreakpointState(): BreakpointState {
    if (typeof window === "undefined") {
        return {
            isMobile: false,
            isTablet: false,
            isDesktop: true,
            sidebarMode: "expanded",
        };
    }

    const isMobile = window.matchMedia(MEDIA_QUERIES.mobile).matches;
    const isTablet = window.matchMedia(MEDIA_QUERIES.tablet).matches;
    const isDesktop = window.matchMedia(MEDIA_QUERIES.desktop).matches;

    let sidebarMode: SidebarLayoutMode = "expanded";
    if (isMobile) sidebarMode = "sheet";
    else if (isTablet) sidebarMode = "collapsed";
    else sidebarMode = "expanded";

    return { isMobile, isTablet, isDesktop, sidebarMode };
}

export function useBreakpoint(): BreakpointState {
    const [state, setState] = useState<BreakpointState>(readBreakpointState);

    useEffect(() => {
        const media = [
            window.matchMedia(MEDIA_QUERIES.mobile),
            window.matchMedia(MEDIA_QUERIES.tablet),
            window.matchMedia(MEDIA_QUERIES.desktop),
        ];

        const onChange = () => setState(readBreakpointState());

        media.forEach((mq) => mq.addEventListener("change", onChange));
        setState(readBreakpointState());

        return () => media.forEach((mq) => mq.removeEventListener("change", onChange));
    }, []);

    return state;
}
